import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
    CheckboxControlValueAccessor,
    ControlValueAccessor,
    FormControl,
    FormGroup,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ErrorFieldComponent } from '../error-field/error-field.component';

/**
 * @example
 *  <siat-switch-field
 *    [formGroup]="formModificaStruttura"
 *    controlName="controlName"
 *    id="ID"
 *    name="Name"
 *    label="Label"
 *    labelPosition="after"
 *  ></siat-switch-field>
 */
@Component({
   
  selector: 'siat-switch-field',
  imports: [CommonModule, ReactiveFormsModule, MatSlideToggleModule, ErrorFieldComponent],
  templateUrl: './switch-field.component.html',
  providers: [CheckboxControlValueAccessor],
})
export class SwitchFieldComponent implements ControlValueAccessor {
  /**
   * The form group the field belongs to.
   */
  @Input()
  formGroup: FormGroup;

  /**
   * The name of the control within the form group.
   */
  @Input()
  controlName: string;

  /**
   * The field label.
   */
  @Input()
  label: string;

  /**
   * The field id.
   */
  @Input()
  id: string;

  /**
   * The field name.
   */
  @Input()
  name: string;

  /**
   * A flag telling whether the field belongs to a group or not.
   */
  @Input()
  belongsToGroup?: boolean;

  /**
   * The field id.
   */
  @Input()
  labelPosition: 'before' | 'after' = 'after';

  /**
   * The style class of the field.
   */
  @Input()
  fieldClass: string;

  /**
   * Gets the form control.
   */
  get control(): FormControl<boolean> {
    return this.formGroup.controls[this.controlName] as FormControl<boolean>;
  }

  /**
   * Gets the value of the control.
   */
  get controlValue(): boolean {
    return this.control.value;
  }

  /**
   * A flag telling whether the control is disabled or not.
   */
  get disabled(): boolean {
    return this.control.disabled;
  }

  /**
   * @inheritdoc
   */
  onChange: (value: boolean) => void = () => {};

  /**
   * @inheritdoc
   */
  onTouched: (value: boolean) => void = () => {};

  /**
   * The write value function.
   */
  writeValue(obj: boolean): void {
    this.control.setValue(obj);
  }

  /**
   * The register on change function.
   */
  registerOnChange(onChangeCallBack: () => boolean): void {
    this.onChange = onChangeCallBack;
    this.control.valueChanges.subscribe(this.onChange);
  }

  /**
   * The register on touched function.
   */
  registerOnTouched(onTouchedCallBack: () => boolean): void {
    this.onTouched = onTouchedCallBack;
  }
}
